var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35425 17.7825C9.35425 17.7825 3 12.9883 3 8.27097C3 6.60781 3.7375 5.01276 5.05025 3.83673C6.36301 2.66069 8.14348 2 10 2C11.8565 2 13.637 2.66069 14.9497 3.83673C16.2625 5.01276 17 6.60781 17 8.27097C17 12.9883 10.6458 17.7825 10.6458 17.7825C10.2922 18.0741 9.71038 18.0709 9.35425 17.7825ZM10 11.0145C10.4022 11.0145 10.8004 10.9436 11.172 10.8057C11.5435 10.6678 11.8811 10.4657 12.1655 10.211C12.4499 9.95619 12.6755 9.65375 12.8294 9.32089C12.9833 8.98802 13.0625 8.63126 13.0625 8.27097C13.0625 7.91069 12.9833 7.55393 12.8294 7.22106C12.6755 6.8882 12.4499 6.58575 12.1655 6.33099C11.8811 6.07623 11.5435 5.87414 11.172 5.73626C10.8004 5.59839 10.4022 5.52742 10 5.52742C9.18777 5.52742 8.40882 5.81647 7.83449 6.33099C7.26016 6.84551 6.9375 7.54334 6.9375 8.27097C6.9375 8.99861 7.26016 9.69644 7.83449 10.211C8.40882 10.7255 9.18777 11.0145 10 11.0145Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrive);
export default __webpack_public_path__ + "static/media/icon-arrive.1da408ccb1d7cdbc86af7af844d2e3a0.svg";
export { ForwardRef as ReactComponent };